<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <!-- data table -->
          <v-col cols="12">
            <v-card class="mx-auto" height="40%" tile>
              <v-img height="100%" :src="require('@/assets/bgBetask.jpeg')">
                <v-row align="end" class="fill-height">
                  <v-col align-self="start" class="pa-0" cols="12">
                    <v-avatar class="profile" color="grey" size="164" tile>
                      <v-img :src="require('@/assets/betask.jpeg')"></v-img>
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-img>
              <br />
              <v-data-table
                :headers="columns"
                :items="dataItem"
                :items-per-page="10"
              >
                <template v-slot:[`item.logo`]="{ item }">
                    <v-avatar
                    color="primary"
                    size="40"
                    > <img
                        :src="item.logo"
                        alt="img"
                    ></v-avatar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <div class="text-center">
                    <v-btn
                      color="question"
                      fab
                      v-if="item.countMember > 0"
                      small
                      @click.stop="getDataMem(item)"
                    >
                      <v-icon dark> mdi-qrcode </v-icon>
                    </v-btn>
                    <v-btn
                      color="primary"
                      fab
                      small
                      class="ml-2"
                      title="ย้ายข้อมูลไปเวอร์ชันใหม่"
                      @click.stop="goMigrate(item)"
                    >
                      <v-icon dark> mdi-database-arrow-right </v-icon>
                    </v-btn>
                    </div>
                </template>
              </v-data-table>
              <v-dialog v-model="dialogView" persistent max-width="1200px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">รายชื่อลูกค้า</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                          <v-row>
                          <v-col cols="12">
                            <v-card>
                              <v-card-text>
                                <v-data-table
                                  :headers="columnsMen"
                                  :items="dataItemMem"
                                >
                                <template v-slot:[`item.CREATE_DATE`]="{ item }">
                                    {{ format_date(item.CREATE_DATE) }}
                                </template>
                                <template v-slot:[`item.picture`]="{ item }">
                                    <v-avatar
                                      color="primary"
                                      size="40"
                                    > <img
                                        :src="item.picture"
                                        alt="img"
                                      ></v-avatar>
                                </template>
                                <template v-slot:[`item.LAST_DATE`]="{ item }">
                                    {{ format_date(item.LAST_DATE) }}
                                </template>
                                </v-data-table>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  @click="dialogView = false"
                                >
                                  Close
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
export default {
  components: {
    'left-menu-admin': adminLeftMenu
  },
  data () {
    return {
      dialogView: false,
      session: this.$session.getAll(),
      columns: [
        { text: 'โลโก้', value: 'logo' },
        { text: 'แอพพลิเคชั่น', value: 'productName' },
        { text: 'ชื่อร้าน', value: 'shopName' },
        { text: 'หมวดหมู่ร้าน', value: 'category' },
        { text: 'จำนวนลูกค้า', value: 'countMember' },
        { text: 'Shop Id', value: 'shopId' },
        { text: 'รายชื่อลูกค้า', value: 'action' }
      ],
      columnsMen: [
        { text: 'รูปโปร', value: 'picture' },
        { text: 'ชื่อลูกค้า', value: 'name' },
        { text: 'Point', value: 'totalPoint' },
        { text: 'Level', value: 'LevelName' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' }
      ],
      dataItem: [],
      dataItemOa: [],
      dataItemMem: [],
      returnLink: '/system/ListAllShop'
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.getDataOa()
    await this.getData()
  },
  methods: {
    goMigrate (dt) {
      this.$router.push('/System/MigrateToV2?shopId=' + dt.shopId)
    },
    async getDataMem (dt) {
      this.dataItemMem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/member/get?shopId=" + dt.shopId
        )
        .then(async response => {
          console.log(response.data)
          if (response.data.status === false) {
            this.dataItemMem = []
            this.dialogView = false
          } else {
            this.dataItemMem = response.data
            this.dialogView = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async getDataOa () {
      this.dataItemOa = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/getList"
        )
        .then(async response => {
          console.log(response.data.bots)
          if (response.data.status === false) {
            this.dataItemOa = []
          } else {
            this.dataItemOa = response.data.bots
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async getData () {
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/sys_all_shop/get"
        )
        .then(async response => {
          console.log('data', response.data)
          if (response.data.status === false) {
            this.columns = []
            this.dataItem = []
          } else {
            console.log('dataItemOa', this.dataItemOa)
            for (var i = 0; i < this.dataItemOa.length; i++) {
              var d = this.dataItemOa[i]
              var s = {}
              s.logo = d.pictureUrl
              const chk = response.data.filter(function (el) {
                return el.shopId === d.userId
              })
              console.log(chk)
              console.log('userId', d.userId)
              if (chk.length > 0) {
                s.productName = chk[0].productName
                s.category = chk[0].category
                s.countMember = chk[0].countMember
              } else {
                s.productName = 'ไม่มีข้อมูล'
                s.category = 'ไม่มีข้อมูล'
                s.countMember = 'ไม่มีข้อมูล'
              }
              s.shopId = d.userId
              s.shopName = d.displayName
              this.dataItem.push(s)
            }
            // this.dataItem = response.data
            console.log(this.dataItem)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/ListAllShop.vue